/// <reference types="./LegacyCodecFieldTypeAdapters.d.ts" />
import { FieldType, } from '@dossierhq/core';
const booleanCodec = {
    decodeData: (it) => it,
    decodeJson: (json) => json,
};
const entityTypeCodec = {
    decodeData: (it) => ({ id: it }),
    decodeJson: (json) => json,
};
const locationCodec = {
    decodeData: ([lat, lng]) => ({ lat, lng }),
    decodeJson: (json) => json,
};
const numberCodec = {
    decodeData: (it) => it,
    decodeJson: (json) => json,
};
const stringCodec = {
    decodeData: (it) => it,
    decodeJson: (json) => json,
};
const invalidCodec = {
    decodeData: (_data) => {
        throw new Error('Should not be used');
    },
    decodeJson: (_json) => {
        throw new Error('Should not be used');
    },
};
const adapters = /* @__PURE__ */ (() => ({
    [FieldType.Boolean]: booleanCodec,
    [FieldType.Component]: invalidCodec,
    [FieldType.Reference]: entityTypeCodec,
    [FieldType.Location]: locationCodec,
    [FieldType.Number]: numberCodec,
    [FieldType.RichText]: invalidCodec,
    [FieldType.String]: stringCodec,
}))();
export function getAdapter(fieldSpec) {
    return getAdapterForType(fieldSpec.type);
}
function getAdapterForType(fieldType) {
    const payload = adapters[fieldType];
    if (!payload) {
        throw new Error(`Can't find field type (${fieldType})`);
    }
    return payload;
}
//# sourceMappingURL=LegacyCodecFieldTypeAdapters.js.map